export default "__VITE_ASSET__PbyZJpob__ 1200w";